<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Order List</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">All Order</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <router-link :to="'/subscriptions'" class="btn add-btn">
                  <i class="fa fa-shopping-cart"></i> Order
                </router-link>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.period" type="month" />
                <label class="focus-label">Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.code" type="text" />
                <label class="focus-label">Invoice</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.member_keywords" type="text" />
                <label class="focus-label">Member (Name/Email/Phone)</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <select class="form-control" v-model="serverParams.columnFilters.status">
                  <option value></option>
                  <option value="pending">Pending</option>
                  <option value="paid">Paid</option>
                  <option value="expired">Expired</option>
                </select>
                <label class="focus-label">Status</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center" style="width:100px;">Invoice Number</th>
                      <th class="text-center">Nama</th>
                      <th class="text-center">Email</th>
                      <th class="text-center">No. WA</th>
                      <th class="text-center">Total (IDR)</th>
                      <th class="text-center" style="width:100px;">Status</th>
                      <th class="text-center">Time</th>
                      <!-- <th>Action</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="6">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-right">{{ row.number }}</td>
                        <td>
                          <router-link :target="'_blank'" :to="'/order-finish?id=' + row.id">
                            <i class="fa fa-file"></i>
                            {{ row.code }}
                          </router-link>
                        </td>
                        <td class="text-left">
                          {{ row.member_name }}
                        </td>
                        <td class="text-left">
                          {{ row.member_email }}
                        </td>
                        <td class="text-left">
                          {{ row.member_mobilephone }}
                        </td>
                        <td class="text-right">{{ formatPriceRupiah(row.total_bill) }}</td>
                        <td class="text-left">
                          <div v-if="row.status == 'pending'" class="text text-warning">
                            {{ row.status }}
                            <div class="text-muted">Pay before:
                              {{ formatLocalDate(convertUTCDatetimeToUnix(row.expire_datetime)) }}</div>
                          </div>

                          <div v-else-if="row.status == 'paid'" class="text text-success">{{ row.status }}</div>
                          <div v-else-if="row.status == 'expired'" class="text text-danger">{{ row.status }}</div>
                          <div v-else class="text text-primary">{{ row.status }}</div>
                        </td>

                        <td class="text-center">{{ formatLocalDate(convertUTCDatetimeToUnix(row.create_datetime)) }}
                        </td>
                      </tr>
                    </template>
                    <template v-if="loading">
                      <tr>
                        <td colspan="6">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' + {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid,
  formatPriceRupiah
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton
  },
  data() {
    return {
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          period: this.getCurrentMonth(),
          status: "",
          code: "",
          member_keywords: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    convertUTCDatetimeToUnix(value) {
      return convertUTCDatetimeToUnix(value);
    },
    formatPriceRupiah(value) {
      return formatPriceRupiah(value);
    },

    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("order/orderList", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>


// WEBPACK FOOTER //
// src/views/order/list.vue